import React from "react";
import { PagingInfo } from "@elastic/react-search-ui";
import { useTranslation } from "react-i18next";

const OmronPagingInfo = () => {
  const { t } = useTranslation();
  return (
    <span className="u-flex u-flex--middle u-flex--end u-mb10">
      <PagingInfo
        view={({ totalResults }) => (
          <span className="u-font--s u-font--bold">
            {t("pagingInfo", { totalResults })}
          </span>
        )}
      />
    </span>
  );
};

export default OmronPagingInfo;
